import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * エリア一覧
 *
 * エリアデータの一覧を返す
 */
export class FetchArea implements APIRequest<Monitaro.FetchAreaResponse> {
  response: Monitaro.FetchAreaResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/areas`
  }
}

/**
 * 自分が所属しているエリア一覧
 *
 * 自分が所属しているエリアデータの一覧を返す
 */
export class FetchAreaMine implements APIRequest<Monitaro.FetchAreaMineResponse> {
  response: Monitaro.FetchAreaMineResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/areas/mine`
  }
}

/**
 * エリアデータの取得
 *
 * 指定されたIDのエリア情報を返す
 */
export class GetArea implements APIRequest<Monitaro.GetAreaResponse> {
  response: Monitaro.GetAreaResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(area: string) {
    this.path = `/areas/${area}`
  }
}
